/* global ga, GA_KEY, _sf_async_config, pSUPERFLY, _cc10461, Sailthru, COMSCORE */

import { GA_TRACKED_LINK_TYPE } from "../config/constants";

function initialize () {
  initGA();
  initComscore();
}

function initGA() {
  ga("create", GA_KEY, "auto");
  ga("require", "displayfeatures");
  ga("send", "pageview");
}

function initComscore() {
  let _comscore = _comscore || [];

  _comscore.push(
    { c1: "2", c2: "24196029" }
  );

  let s = document.createElement("script");
  let el = document.getElementsByTagName("script")[0];
  s.async = true;
  s.src = (document.location.protocol === "https:" ? "https://sb" : "http://b") + ".scorecardresearch.com/beacon.js";
  el.parentNode.insertBefore(s, el);
}

function setUser(id) {
  id && ga("set", "dimension1", id);
}

function setStream (stream) {
  stream && ga("set", "dimension8", stream);
}

function setSections(sections) {
  _sf_async_config.sections = sections.map((s) => s.slug).join(",");
}

function setAuthors(authors) {
  _sf_async_config.authors = authors.map((author) => author.username).join(",");
}

function pageView() {
  ga("send", "pageview");
}

/*
  This event should be triggered if a post is still in view 3 seconds
  after it was initially registered in the viewport
 */
function userScrollsStoryIntoView(story) {
  let unpinned = story.is_featured && !story.new_featured;
  ga("send", {
    hitType: "pageview",
    title: story.headline,
    page: story.permalink,
    dimension4: story.is_featured && !unpinned ? "Yes" : "",
    dimension5: unpinned ? "Yes" : "",
  });

  // Chartbeat
  setSections(story.sections.concat(story.primary_section || []));
  setAuthors(story.authors);
  pSUPERFLY.virtualPage(story.permalink, story.headline);

  // Lotame
  const sectionTags = story.sections.concat(story.primary_section || []).map((s) => s.slug)
    .concat(story.tags.concat(story.primary_tag || []).map((t) => t.name));
  let postAttributes = sectionTags.join().replace(/ /g,"_");
  _cc10461.bcpw("int",postAttributes,"act",postAttributes);

  // Sailthru
  Sailthru.SPM.trackPageView(story.permalink, {});

  // Comscore
  (typeof COMSCORE !== "undefined" && COMSCORE.beacon(
    { c1: "2", c2: " 24196029" }
  ));
}

function userClicksOnTrackedLink(streamSlug, actionName, buttonLabel) {
  const stream = streamSlug || "";
  ga("send", {
    hitType: "event",
    eventCategory: `clicks_${stream}`,
    eventAction: `clicks_${stream}_${actionName}`,
    eventLabel: `Clicks on ${buttonLabel} in ${stream}`,
  });
}

const userClicksInternalLink = (stream, label) =>
  userClicksOnTrackedLink(stream, GA_TRACKED_LINK_TYPE.LINK, label);

const userClicksSaveTag = (stream) =>
  userClicksOnTrackedLink(stream, GA_TRACKED_LINK_TYPE.SAVE, "Save button");

const userClicksReadAnother = (stream) =>
  userClicksOnTrackedLink(stream, GA_TRACKED_LINK_TYPE.READ_ANOTHER, "Read another button");

const userClicksKeepReading = (stream) =>
  userClicksOnTrackedLink(stream, GA_TRACKED_LINK_TYPE.READ_MORE, "Keep reading button");

const userClicksCopyLink = (stream) =>
  userClicksOnTrackedLink(stream, GA_TRACKED_LINK_TYPE.SS_CL, "Copy link button");

const userClicksFacebook = (stream) =>
  userClicksOnTrackedLink(stream, GA_TRACKED_LINK_TYPE.SS_FB, "Facebook share button");

const userClicksTwitter = (stream) =>
  userClicksOnTrackedLink(stream, GA_TRACKED_LINK_TYPE.SS_TW, "Twitter share button");

const userClicksLinkedIn = (stream) =>
  userClicksOnTrackedLink(stream, GA_TRACKED_LINK_TYPE.SS_LI, "LinkedIn share button");

export default {
  initialize,
  setUser,
  setStream,
  setSections,
  setAuthors,
  pageView,
  userScrollsStoryIntoView,
  userClicksOnTrackedLink,
  userClicksInternalLink,
  userClicksSaveTag,
  userClicksReadAnother,
  userClicksKeepReading,
  userClicksCopyLink,
  userClicksFacebook,
  userClicksTwitter,
  userClicksLinkedIn,
};



// WEBPACK FOOTER //
// ./src/utils/analytics.js